// extracted by mini-css-extract-plugin
export default {"container":"MobileLayout_container__HybMI","content":"MobileLayout_content__xn1UM","footer":"MobileLayout_footer__MDzyc"};